/*
 * @Author: Teemo Ding
 * @Date: 2021-04-19 14:54:16
 * @LastEditTime: 2021-04-20 11:55:23
 * @LastEditors: Please set LastEditors
 * @Description: Click Item on the jump page
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelPreviewPageComponents/GeneralLinkItem/index.tsx
 */
import React from 'react';
import style from './style.module.less';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import { ArrowRightOutlined } from '@ant-design/icons';

const GeneralLinkItem = (props) => {
  const { title, options, err, onClick } = props;
  return (
    <div className={style.item} onClick={onClick}>
      <GeneralCollapseHeader
        err={err}
        hasDots={!!options.length}
        dotsFunction={options}
        content={title}></GeneralCollapseHeader>
      <div className={style.icon}>
        <ArrowRightOutlined />
      </div>
    </div>
  );
};

export default GeneralLinkItem;
